import unicornsRoutes from './unicorns';
import princessesRoutes from './princesses';

export default {
  ...unicornsRoutes,
  ...princessesRoutes,
};
